// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.89-TSS-3097-mcastro-BUG-Guest-Accounts-Able-to-Change-Cells-in-Member-Only-Columns.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
